import { useEffect, useRef } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useVerifyEmail } from '../hooks/useVerifyEmail'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { getErrorMessage } from '@/lib/utils/errors'

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const { mutate: verify, isPending, isSuccess, isError, error } = useVerifyEmail()
  const hasVerified = useRef(false)

  useEffect(() => {
    if (token && !hasVerified.current) {
      hasVerified.current = true
      verify(token)
    }
  }, [token, verify])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-4">
        <div className="flex justify-center">
          <img src="/vectorFP3Logo.svg" alt="FP3 Finance" className="h-24" />
        </div>
        <Card>
          <CardHeader>
            <CardTitle>Email Verification</CardTitle>
          </CardHeader>
          <CardContent>
            {!token && <p className="text-sm text-destructive">No verification token provided.</p>}
            {isPending && <p className="text-sm text-muted-foreground">Verifying your email...</p>}
            {isSuccess && (
              <div className="space-y-3">
                <p className="text-sm text-success">Your email has been verified.</p>
                <Link
                  to="/login?verified=true"
                  className="text-primary hover:underline font-medium text-sm"
                >
                  Continue to login
                </Link>
              </div>
            )}
            {isError && (
              <div className="space-y-3">
                <p className="text-sm text-destructive">{getErrorMessage(error)}</p>
                <Link to="/register" className="text-primary hover:underline font-medium text-sm">
                  Back to registration
                </Link>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
